
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { API_TAccount, TAccount, TTime_Stamp } from "@/models/account";
import { SMToaster, SMUser } from "@/store";
import { SUCCESS_NOTIFICATION_TYPE } from "@/constants/notification";

const PASSWORD_STRING = "000000000";

const MASKS = {
  phoneEmployer: "0NNNNNNNNNNNNNNNNN",
  phone: "NNNNNNNNNNNNNNNNNN",
};

@Component({
  components: {
    ActionButtons: () => import("@/components/ActionContainer/ActionButtons.vue"),
    ConfirmIdentityPopup: () =>
      import("@/pages/Layout/views/Employer/views/MyAccount/components/ConfirmIdentityPopup.vue"),
    CodePopup: () =>
      import("@/pages/Layout/views/Employer/views/MyAccount/components/CodePopup.vue"),
    ChangePasswordPopup: () =>
      import("@/pages/Layout/views/Employer/views/MyAccount/components/ChangePasswordPopup.vue"),
  },
})
export default class Account extends Vue {
  loading = true;

  saveLoading = false;

  dialogs = {
    confirmIdentity: false,
    code: false,
    changePassword: false,
  };

  password = PASSWORD_STRING;

  masks = MASKS;

  titleOptions = [
    { value: this.$root.$tc("titles.mr"), label: this.$root.$tc("titles.mr") },
    { value: this.$root.$tc("titles.mrs"), label: this.$root.$tc("titles.mrs") },
    { value: this.$root.$tc("titles.miss"), label: this.$root.$tc("titles.miss") },
    { value: this.$root.$tc("titles.ms"), label: this.$root.$tc("titles.ms") },
  ];

  isCompianceAdmin = false;

  account: TAccount = {
    email: "",
    first_name: "",
    job_position: "",
    last_name: "",
    phone: "",
    title: "",
  };

  accountInitial: TAccount = { ...this.account };

  async mounted() {
    await this.fetchMyAccount();
  }

  async fetchMyAccount() {
    try {
      this.loading = true;

      const { data } = await this.axios.get<API_TAccount>(API_ROUTES.MY_ACCOUNT);

      if (!data) return;

      this.isCompianceAdmin = data.is_compliance_admin;

      delete data.is_compliance_admin;

      this.account = data;

      this.accountInitial = { ...data };
    } catch (e) {
      SMToaster.emitError(e);
    } finally {
      this.loading = false;
    }
  }

  get isSaveDisabled() {
    const isDataNotChanded = JSON.stringify(this.account) === JSON.stringify(this.accountInitial);

    const isFieldEmpty = !!Object.values(this.account).filter((item) =>
      item ? !item.trim() : !item
    ).length;

    return isDataNotChanded || isFieldEmpty;
  }

  timeStamp = 0;

  async sendCode() {
    try {
      const { data } = await this.axios.get<TTime_Stamp>(API_ROUTES.MY_ACCOUNT_PASSWORD);

      if (!data) return;

      this.timeStamp = data.time_stamp;
    } catch (e) {
      SMToaster.emitError(e);
    } finally {
      this.openCodePopup();

      this.closeConfirmIdentityPopup();
    }
  }

  onCodeOk() {
    this.openChangePasswordPopup();

    this.closeCodePopup();
  }

  openConfirmIdentityPopup() {
    this.dialogs.confirmIdentity = true;
  }

  closeConfirmIdentityPopup() {
    this.dialogs.confirmIdentity = false;
  }

  openCodePopup() {
    this.dialogs.code = true;
  }

  closeCodePopup() {
    this.dialogs.code = false;
  }

  openChangePasswordPopup() {
    this.dialogs.changePassword = true;
  }

  closeChangePasswordPopup() {
    this.dialogs.changePassword = false;
  }

  async saveUpdateAccount() {
    try {
      this.saveLoading = true;

      const account = {
        email: this.account.email.trim(),
        first_name: this.account.first_name.trim(),
        job_position: this.account.job_position.trim(),
        last_name: this.account.last_name.trim(),
        phone: this.account.phone.trim(),
        title: this.account.title.trim(),
      };

      await this.axios.post<TAccount>(API_ROUTES.MY_ACCOUNT, account);

      await SMUser.updateCurrentUser();

      this.account = { ...account };

      this.accountInitial = { ...account };

      this.$root.$emit("show-notification", {
        type: SUCCESS_NOTIFICATION_TYPE,
        title: this.$tc("notification.changesSaved"),
      });
    } catch (e) {
      SMToaster.emitError(e);
    } finally {
      this.saveLoading = false;
    }
  }

  cancelUpdateAccount() {
    this.account = { ...this.accountInitial };
  }

  get phoneMask() {
    return this.masks.phoneEmployer;
  }
}
